<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/about-banner.png`)})`}">
				<h2 class="banner-title">iSafeClub - Web3行业技术安全协会</h2>
				<p class="banner-note">技术重塑规则 安全掌控未来</p>
				<p class="banner-info">遵循“平等、创新、守护”的精神，凝聚“共识、共治、共赢”的力量，编织可持续的区块链安全网络。</p>
				<ul class="banner-list center70">
					<li class="banner-item">
						<div class="banner-list-info">会员人数</div>
						<div class="banner-list-num">
							<countTo
								:endVal="100"
								:autoplay="true"
								:duration="1500"
								suffix="+"
							/>
						</div>
					</li>
					<li class="banner-item">
						<div class="banner-list-info">合作企业</div>
						<div class="banner-list-num">
							<countTo
								:endVal="30"
								:autoplay="true"
								:duration="1500"
								suffix="+"
							/>
						</div>
					</li>
					<li class="banner-item">
						<div class="banner-list-info">举办活动</div>
						<div class="banner-list-num">
							<countTo
								:endVal="20"
								:autoplay="true"
								:duration="1500"
								suffix="+"
							/>
						</div>
					</li>
				</ul>
			</div>

			<section class="company-info">
				<h2 class="title center70">简介</h2>
				<div class="info-cont center70">
					<p>
						Web3行业技术及安全交流协会是Web3技术专家与安全实践者探索技术前沿、共享安全经验的平台；是行业精英与开发者推动区块链技术革新、共筑安全防线的协作空间；是连接Web3生态参与者与跨领域合作伙伴的开放桥梁；是提升技术影响力、强化行业归属感、激发创新活力、倡导去中心化协作的全球性顶级社群，隶属于中国区块链技术与安全协会。
					</p>
					<p>
						Web3行业技术及安全交流协会会员由理事单位、企业会员及个人会员组成。其中，个人会员涵盖全球知名Web3项目创始人、首席技术官（CTO）、首席安全官（CSO）、区块链架构师、智能合约开发者、DeFi协议创始人，以及专注数字资产安全、隐私计算、去中心化治理等领域的技术领袖与行业高管。
					</p>
				</div>
				<h3 class="title center70">我们的使命</h3>
				<div class="info-cont center70">
					<p>愿景宣言：“构建无信任边界的Web3安全生态”。</p>
				</div>
				<h3 class="title center70">核心价值</h3>
				<div class="pic-container" :style="{'background-image': `url(${require(`@/assets/images/jz-bg.png`)})`}">
					<div class="center70">
						<ul class="icon-list clearF">
							<li class="icon-item fl"><img class="icon-img" src="@/assets/images/jz1.png" alt="技术共享">
								<p>技术共享</p>
							</li>
							<li class="icon-item fl"><img class="icon-img" src="@/assets/images/jz2.png" alt="风险预防">
								<p>风险预防</p>
							</li>
							<li class="icon-item fl"><img class="icon-img" src="@/assets/images/jz3.png" alt="合规协同">
								<p>合规协同</p>
							</li>
						</ul>
					</div>
				</div>
			</section>

			<section class="members">
				<h2 class="title center70">理事会成员</h2>
				<div class="center70">
					<div class="member-list">
						<div class="member">
							<img src="@/assets/images/member-binance.png">
						</div>
						<div class="member">
							<img src="@/assets/images/member-okx.png">
						</div>
						<div class="member">
							<img src="@/assets/images/member-huobi.png">
						</div>

						<div class="member">
							<img src="@/assets/images/member-bybit.png">
						</div>
					</div>
				</div>
			</section>
			<section class="org">
				<h2 class="title center70">组织架构</h2>
				<div class="center70 org-img">
					<img src="@/assets/images/org.jpg">
				</div>
			</section>
    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'
    import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
    import Icon from "@/components/icon/Icon.vue";
		import countTo from 'vue-count-to'

    export default {
        name: 'About',
        components: {Icon, SectionTitle, Layout, countTo},
        data() {
            return {
						}
        }
    }
</script>
<style scoped lang="scss">
section.company-info {
	margin-top: 40px;
	padding: 0;
	h2.title {
		font-weight: 700;
		letter-spacing: 40px;
		position: relative;
		font-size: 40px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		&:after {
			content: "";
			position: absolute;
			bottom: 0;
			left: 0;
			width: 120px;
			height: 6px;
			background-color: #0d6efd;
		}
	}
	.info-cont {
		margin-bottom: 50px;
		p {
			font-size: 18px;
			line-height: 2;
			margin-bottom: 10px;
		}
	}
	h3.title {
		font-size: 26px;
		font-weight: 700;
		margin-bottom: 30px;
	}
	.pic-container {
		background-position: 50%;
		background-repeat: no-repeat;
		background-size: cover;
		ul.icon-list {
			padding: 80px 0 40px;
			display: flex;
			margin-bottom: 0;
			li.icon-item {
				width: 33%;
				text-align: center;
				img {
					height: 98px;
					margin: 0 auto 30px;
				}
				p {
					font-size: 18px;
					font-weight: bold;
					color: #ffffff;
				}
			}
		}
	}
}
section.members {
	background-color: #f4f4f4;
	padding: 80px 0 40px;
	h2.title {
		font-weight: 700;
		position: relative;
		font-size: 40px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		&:after {
			content: "";
			position: absolute;
			bottom: 0;
			left: 0;
			width: 200px;
			height: 6px;
			background-color: #0d6efd;
		}
	}
	.member-list {
		display: flex;
		margin: 80px 0;
		justify-content: space-between;
		.member {
			transition: .6s;
			img {
				width: 240px;
				border-radius: 8px;
			}
			&:hover {
				transform: translateY(-5px);
			}
		}
	}
}
section.org {
	margin-top: 80px;
	h2.title {
		font-weight: 700;
		position: relative;
		font-size: 40px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		&:after {
			content: "";
			position: absolute;
			bottom: 0;
			left: 0;
			width: 160px;
			height: 6px;
			background-color: #0d6efd;
		}
	}
}
@media screen and (max-width: 850px) {
	section.company-info {
		margin-top: 20px;
		h2.title {
			font-size: 28px;
			&:after {
				width: 96px;
			}
		}
		.pic-container {
			ul.icon-list {
				flex-direction: column;
				align-items: center;
				gap: 40px;
			}
		}
	}
	section.members {
		padding-top: 40px;
		h2.title {
			font-size: 28px;
			margin-bottom: 0;
			&:after {
				width: 140px;
			}
		}
		.member-list {
			margin-top: 40px;
			flex-direction: column;
			align-items: center;
			gap: 40px;
		}
	}
	section.org {
		margin-top: 40px;
		margin-bottom: 40px;
		h2.title {
			font-size: 28px;
			margin-bottom: 0;
			&:after {
				width: 110px;
			}
		}
		.org-img {
			margin-top: 20px;
		}
	}
}
</style>
